module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-text', {
    staticClass: "text-sm-left"
  }, [_vm._v("\n          活動方式：下載『遊臺中學英語』APP，使用課程完成學習任務，即有機會獲得獎勵金幣，參加兌換活動。\n          "), _c('div', {
    staticClass: "hidden-sm-and-down",
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("金幣餘額："), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$store.getters.user.GoldCount))])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-right hidden-md-and-up"
  }, [_vm._v("\n          金幣餘額："), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$store.getters.user.GoldCount))])])], 1)], 1)], 1), _vm._v(" "), _c('v-row', _vm._l((_vm.items), function(n) {
    return _c('v-col', {
      key: n.Id,
      staticClass: "mt-3",
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('v-card', [_c('v-card-row', {
      staticStyle: {
        "background-color": "#4a4a66"
      }
    }, [_c('v-card-title', [_c('span', {
      staticClass: "white--text",
      staticStyle: {
        "height": "2.5em"
      }
    }, [_vm._v(_vm._s(n.Name))]), _vm._v(" "), _c('v-spacer')], 1)], 1), _vm._v(" "), (n.Cover !== null) ? _c('v-card-row', {
      attrs: {
        "img": n.Cover,
        "height": "300px"
      }
    }) : _c('v-card-row', {
      attrs: {
        "img": "http://placehold.it/320x300",
        "height": "300px"
      }
    }), _vm._v(" "), _c('v-card-row', {
      staticClass: "mt-0",
      staticStyle: {
        "background-color": "#4a4a66"
      },
      attrs: {
        "actions": ""
      }
    }, [_c('v-btn', {
      staticClass: "white--text",
      attrs: {
        "flat": ""
      }
    }, [_vm._v("金幣：" + _vm._s(n.GoldNum))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.buy(n)
        }
      }
    }, [_c('v-icon', {
      staticClass: "white--text"
    }, [_vm._v("shopping_basket")])], 1)], 1)], 1)], 1)
  })), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0 mt-3"
  }, [_c('v-card-text', [_vm._v("\n      注意事項："), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "pa-3 notice"
  }, [_c('li', [_vm._v("參加者須確保會員帳戶有效性及個人資料正確性，若有無效或錯誤者，視同放棄兌換權利。")]), _vm._v(" "), _c('li', [_vm._v("於『遊臺中學英語』APP所獲得的獎勵金幣一經兌換即不得要求取消、退點或更換兌換內容。")]), _vm._v(" "), _c('li', [_vm._v("本商品兌換僅限所載之指定商品，不得要求更換商品、加購折抵、將兌換內容折抵、兌換現金，亦不得與其他促銷活動合併使用，商品圖示僅供參考，實際商品請以實物為準。兌換內容之使用方式悉依本公司相關規定為準。")]), _vm._v(" "), _c('li', [_vm._v("『遊臺中學英語』APP活動如有任何因電腦、網路、電話、技術或其他不可歸責於本公司之事由，致參加者所填寫之資料有遺失、錯誤、無法辨識或毀損等情形，本公司不負任何法律責任，參加者亦不得異議。")]), _vm._v(" "), _c('li', [_vm._v("參加者若以惡意之電腦程式、違反『遊臺中學英語』APP活動相關辦法、偽造、詐欺或其他不正當行為或其他明顯違反活動公平性之方式參加活動者，本公司有權取消其兌換商品資格，已兌換商品方案者，需立即返還，如已使用應予賠償，本公司保留所有法律上之權利。")]), _vm._v(" "), _c('li', [_vm._v("本公司有權於公告後隨時以公告或電子郵件通知方式解釋、補充、修改、變更本活動及『遊臺中學英語』APP活動辦法及相關內容，並得隨時取消、終止、變更、修正或暫停本活動及『遊臺中學英語』APP活動。如需詢問遊臺中學英語APP相關訊息，請洽客服專線：02-25782626。")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6be9245a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shop.vue
// module id = 635
// module chunks = 1